export const actId = '3e4e13e4-51f1-4eb3-9a84-c06a42057e78';

// 排序类型默认0，0=最热  1=最新
export const SORT_MAP = [
  {
    label: '按热度排序',
    value: 0
  },
  {
    label: '按最新排序',
    value: 1
  }
];
